<app-attendee-layout *ngIf="cmsPage">
  <app-attendee-jumbotron
    class="block -mt-4 -mx-3 xs:-mx-6 sm:-mx-9 lg:-mt-5"
    [title]="cmsPage.title"
    [description]="cmsPage.description"
    [imgMobile]="cmsPage.jumbotron?.imageMobile"
    [imgDesktop]="cmsPage.jumbotron?.imageDesktop"
    [variant]="jumbotronVariant"
    [backLink]="backLink"
    [backLinkAriaLabel]="
      'a11y.attendee.offer_page.header.back_link.label' | translate
    "
  >
  </app-attendee-jumbotron>

  <app-attendee-filters>
    <app-attendee-city-autocomplete
      #autocomplete
      *ngIf="isActivitiesPage"
      class="block w-full mb-4 md:w-1/2 lg:w-1/3"
      [placeholder]="'attendee.offer_page.search_input.placeholder' | translate"
      [ariaLabel]="'attendee.offer_page.search_input.placeholder' | translate"
      [defaultPlaceValue]="defaultPlaceValue"
      [defaultRadiusValue]="defaultRadiusValue"
      (selectedPlace)="selectPlace($event)"
      (selectedRadius)="selectRadius($event)"
      (isCleared)="handleAutocompleteClear()"
    >
    </app-attendee-city-autocomplete>

    <app-attendee-sport-filter
      #sportFilter
      *appListItem
      [selectedSportGroupIdsFromUrl]="defaultSportGroupValue"
      (selected)="setSelectedSportGroup($event)"
    ></app-attendee-sport-filter>

    <app-attendee-date-filter
      #dateFilter
      *appListItem
      (selected)="setSelectedDateRange($event)"
      [defaultValue]="defaultDateFilterValue"
    ></app-attendee-date-filter>
  </app-attendee-filters>

  <section>
    <div class="spinner mx-auto my-8" *ngIf="isLoading"></div>
    <div *ngIf="totalItems > 0 && !isLoading" class="vtmn-title-4 mt-4">
      {{ totalItems | totalResults }}
    </div>
    <app-attendee-pagination
      *ngIf="!isLoading"
      class="block mt-4"
      [bottomBanner]="cmsPage?.banner"
      [items]="items"
      [itemsType]="itemsType"
      [hasLoadMoreButton]="hasLoadMoreButton"
      (filterReset)="resetFilter()"
    >
    </app-attendee-pagination>
    <app-list-pagination
      *ngIf="!isLoading && pagination"
      [pagination]="pagination"
      [targetUrl]="paginationPage"
    />
  </section>
  <ng-container *ngIf="cmsPage && cmsPage?.sections">
    <app-cms-section
      [section]="section"
      *ngFor="let section of cmsPage?.sections; let index = index"
    ></app-cms-section>
  </ng-container>
</app-attendee-layout>
